/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_ToastInputs */

const en_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project was published successfully`)
};

const fr_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet publie avec succes`)
};

const de_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Projekt wurde erfolgreich veröffentlicht.`)
};

const it_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il progetto è stato pubblicato con successo`)
};

const ru_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект успешно опубликован.`)
};

const es_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El proyecto se publicó con éxito`)
};

const zh_cn2_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目已成功发布`)
};

const ja_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトは正常に公開されました`)
};

const hi_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना सफलतापूर्वक प्रकाशित हुई।`)
};

const pt_pt2_iconik_publish_success_toast = /** @type {(inputs: Iconik_Publish_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O projeto foi publicado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Project was published successfully" |
*
* @param {Iconik_Publish_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_toast = /** @type {((inputs?: Iconik_Publish_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_success_toast(inputs)
	if (locale === "de") return de_iconik_publish_success_toast(inputs)
	if (locale === "it") return it_iconik_publish_success_toast(inputs)
	if (locale === "ru") return ru_iconik_publish_success_toast(inputs)
	if (locale === "es") return es_iconik_publish_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_success_toast(inputs)
	if (locale === "ja") return ja_iconik_publish_success_toast(inputs)
	if (locale === "hi") return hi_iconik_publish_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_success_toast(inputs)
	return en_iconik_publish_success_toast(inputs)
});